export const ru = {
    full: 'Полный',
    partial: 'Частичный'
};
